import './ModalNotification.css'

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { IMAGES } from 'assets'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Image from '../Image/Image'

function ModalNotification({ message, showModalNotification = () => {}, onClose = () => {} }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  const handleCloseDialog = () => {
    setOpen(false)
    showModalNotification(false)
    onClose()
  }
  return message ? (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      maxWidth={false}
      aria-labelledby="draggable-dialog-title"
      id="dialog__message"
    >
      <DialogTitle className="dialog__message-title">{t('commonComponent.modal.titleDialog')}</DialogTitle>
      <DialogContent className="dialog__message-content">
        <Image
          src={IMAGES.ICON.ALERT_ICON}
          className="icon_warning"
          style={{ width: 25, height: 25, marginRight: 10 }}
        />
        <DialogContentText>
          <div dangerouslySetInnerHTML={{ __html: message }} className="text-center"></div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="dialog__message-action">
        <Button onClick={handleCloseDialog} color="primary">
          {'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null
}

export default ModalNotification
